import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";
import "./SustainabilityStatusPage.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, LoadingSpinner, ToastMessage } from '../../components'
import ItemList from '../../containers/ItemList/ItemList'
import formatDate from '../../helpers/formatDate';
import havePermissionTo from '../../utils/havePermission';
import UploadFiles from "../../components/UploadFiles/UploadFiles";
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS } from '../../utils/constants';


function SustainabilityStatusPage(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
	const permissions = useSelector(state => state.authorization.permissions);

	const orderList = useSelector(state => state.orderList);
	const isloadingSustainabilitySave = useSelector(state => state.conciliationResult.isloadingSustainabilitySave);
	const isloadingStatusPage = useSelector(state => state.conciliationResult.isloadingStatusPage);
	const lastCertificateDetails = useSelector(state => state.conciliationResult.lastCertificateDetails.buscarDetalhesUltimoCertificadoPorPedido);
	const certificateHistoryList = useSelector(state => state.conciliationResult.certificateHistoryList.buscarPorPedido);
	const reload = useSelector(state => state.conciliationResult.reload);


	const pageMessages = messages[lang].sustainabilityStatusPage
	const titleTable = pageMessages.certificateHistory;
	const titlePage = `Certificado de sustentabilidade: Pedido ${props.history.location.orderId ? props.history.location.orderId : (orderList[0] ? orderList[0].id : '')}`;

	const [editableFields, setEditableFields] = useState({
		id: null,
		statusId: "",
		certificadoValido: "",
		codigoCertificado: "",
		file: undefined,
		conciliacaoAprovada: "",
		avaliacao: "",
		anotacoes: "",
		dataExpedicao: "",
		dataValidade: "",
		certificadoComPeriodoVigenciaAtivo: "",
		buyerIDNumberIgualALoja: "",
		qtdBCCUs: null,
		codigoODNRepetido: "",
		codigoCertificadoODN: "",
		qtdBCCUsDentroDaMargemDeErro: ""
	});

	const [disableSaveButton, setDisableSaveButton] = useState(true);
	const [blockEdit, setBlockEdit] = useState(true);

	const toast = useSelector(state => state.conciliationResult.sustainabilityStatusToast);

	const [showToast, setShowToast] = useState(false);
	const [messageError, setMessageError] = useState('');
	const [messageType, setMessageType] = useState('toast-success');
	const [pageToGoBack, setPageToGoBack] = useState('/conciliation-status');

	const ACCEPT_TYPE = 'application/pdf';
	const [uploadedFile, setUploadedFile] = useState(null);

	const header = [
		pageMessages.reveiveDate,
		pageMessages.status,
		pageMessages.file,
	];

	const pageBack = () => {
		props.history.push(pageToGoBack);
	};

	useEffect(() => {
		setShowToast(toast.showToast)
		setMessageError(toast.message)
		setMessageType(toast.messageType)
		setDisableSaveButton(true)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toast]);

	useEffect(() => {
		getInfoSustainability();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (reload) {
			getInfoSustainability();
			dispatch({ type: "SUSTAINABILITY_DETAILS_RELOAD", payload: false });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [reload]);

	const getInfoSustainability = () => {
		let orderId
		let tipoCertificado

		if (props.history.location.from === '/sustainability-list') {
			setPageToGoBack('/sustainability-list')

			orderId = props.history.location.orderId ? props.history.location.orderId : ''
			tipoCertificado = props.history.location.tipoCertificado ? props.history.location.tipoCertificado : ''
		} else {
			orderId = orderList[0] ? orderList[0].id : ''
		}

		dispatch({
			type: 'GET_LAST_CERTIFICATE_DETAILS',
			orderId: orderId,
			tipoCertificado: tipoCertificado === 'Algodão Certificado BCI' ? ALGODAO_BCI : DEMAIS_ATRIBUTOS_SUSTENTAVEIS
		})

		dispatch({
			type: 'GET_ORDER_CERTIFICATE_HISTORY',
			orderId: orderId,
			tipoCertificado: tipoCertificado === 'Algodão Certificado BCI' ? ALGODAO_BCI : DEMAIS_ATRIBUTOS_SUSTENTAVEIS
		})

		if (havePermissionTo("edit-sustainability-status", permissions)) {
			setBlockEdit(false)
		}
	}

	useEffect(() => {
		if (lastCertificateDetails.id) {
			setEditableFields({
				id: lastCertificateDetails.id,
				statusId: lastCertificateDetails.statusId,
				certificadoValido: lastCertificateDetails.certificadoValido,
				codigoCertificado: lastCertificateDetails.codigoCertificado,
				conciliacaoAprovada: lastCertificateDetails.conciliacaoAprovada,
				avaliacao: lastCertificateDetails.avaliacao,
				anotacoes: lastCertificateDetails.anotacoes,
				dataExpedicao: lastCertificateDetails.dataExpedicao,
				dataValidade: lastCertificateDetails.dataValidade,
				certificadoComPeriodoVigenciaAtivo: lastCertificateDetails.certificadoComPeriodoVigenciaAtivo,
				buyerIDNumberIgualALoja: lastCertificateDetails.buyerIDNumberIgualALoja,
				qtdBCCUs: lastCertificateDetails.qtdBCCUs,
				codigoODNRepetido: lastCertificateDetails.codigoODNRepetido,
				codigoCertificadoODN: lastCertificateDetails.codigoCertificadoODN,
				qtdBCCUsDentroDaMargemDeErro: lastCertificateDetails.qtdBCCUsDentroDaMargemDeErro
			})
		} else {
			setDisableSaveButton(true)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lastCertificateDetails]);

	const mappedCertificateHistoryList = () => {
		return certificateHistoryList.map((item) => {
			return [
				formatDate(item.dataCadastro),
				item.status.descricao,
				item.file ?
					{
						text: <i className="icon-download" />,
						onClick: () => { downloadPdf(item.file) },
					} : '',
			]

		});
	}

	const downloadPdf = (file) => {
		const byteCharacters = window.atob(file);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		const blob = new Blob([byteArray], { type: 'application/pdf' });

		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = messages[lang].filePDFSustainabilityCertificate;
		link.click();
	}

	const updateFields = (fields) => {
		if (lastCertificateDetails.id) {
			setEditableFields(fields)
			setDisableSaveButton(false)
		}
	};

	const saveCertificate = () => {
		dispatch({
			type: 'UPDATE_SUSTAINABILITY_CERTIFICATE',
			payload: editableFields
		})
		setUploadedFile(undefined);
	}

	const saveButton = disabled => () =>
		<ButtonStandard
			id="certificate_save_button"
			text={messages[lang].save}
			textClass="text-2"
			isLoading={isloadingSustainabilitySave}
			disabled={disabled}
			className="btn btn-primary btn-save btn-light"
			onClick={() => saveCertificate()}
		/>;

	const statusOptions = [
		{ id: "0", message: "AGUARDANDO APROVAÇÃO" },
		{ id: "1", message: "APROVADO" },
		{ id: "2", message: "REPROVADO" },
	];

	const validateAndStoreLocalFile = file => {
		setUploadedFile(undefined);

		if (!file || file.length === 0) {
			setShowToast(true);
			setMessageType('toast-error')
			setMessageError(messages[lang].mustBePDF);
		} else if (file.length > 1) {
			setShowToast(true);
			setMessageError('error');
		} else if (file[0].type !== ACCEPT_TYPE) {
			setShowToast(true);
			setMessageError(messages[lang].mustBePDF);
		} else {
			setUploadedFile(file[0]);
			setDisableSaveButton(false);
		}
	};

	const removeFile = () => {
		setUploadedFile(undefined);
	};

	useEffect(() => {
		updateFields(
			{ ...editableFields, file: uploadedFile },
		)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uploadedFile]);

	const isAlgodaoBCI = () => {
		return lastCertificateDetails.tipoCertificado === 'Algodão Certificado BCI'
	}

	return (
		<div className="sustainability-status-page">
			<ToastMessage
				show={showToast}
				setShow={setShowToast}
				message={messageError}
				toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={titlePage}
			/>

			{
				isloadingStatusPage ?
					<div className="loader">
						<LoadingSpinner />
					</div>
					:
					<div>
						<Container className="pt-3 justify-content-start">
							<Form className="px-3">
								{
									isAlgodaoBCI() &&
									<Form.Group className="mt-1">
										<Form.Label className="text-2">{pageMessages.certificateCode}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.codigoCertificado}
											onChange={event => updateFields(
												{ ...editableFields, codigoCertificado: event.target.value },
											)}
											disabled={blockEdit || isloadingSustainabilitySave} />
									</Form.Group>
								}
								{
									!isAlgodaoBCI() &&
									<Row>
										<Form.Group as={Col}>
											<Form.Label className="text-2">{pageMessages.dataExpedicao}</Form.Label>
											<Form.Control
												className="text-2 border-radius-full"
												type="date"
												defaultValue={lastCertificateDetails.dataExpedicao}
												onChange={event => updateFields(
													{ ...editableFields, dataExpedicao: event.target.value },
												)}
												disabled={blockEdit || isloadingSustainabilitySave} />
										</Form.Group>
										<Form.Group as={Col}>
											<Form.Label className="text-2">{pageMessages.dataValidade}</Form.Label>
											<Form.Control
												className="text-2 border-radius-full"
												type="date"
												defaultValue={lastCertificateDetails.dataValidade}
												onChange={event => updateFields(
													{ ...editableFields, dataValidade: event.target.value },
												)}
												disabled={blockEdit || isloadingSustainabilitySave} />
										</Form.Group>


									</Row>
								}
								<Form.Group className="mt-1">
									<Form.Label className="text-2">{pageMessages.certificateType}</Form.Label>
									<Form.Control
										className="text-2 border-radius-full"
										type="text"
										defaultValue={lastCertificateDetails.tipoCertificado}
										disabled={true} />
								</Form.Group>

								<Row>
									<Form.Group as={Col}>
										<Form.Label className="text-2">{pageMessages.udaId}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.idUDA}
											disabled={true} />
									</Form.Group>

									<Form.Group as={Col}>
										<Form.Label className="text-2">{pageMessages.udaCode}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.codigoUDA}
											disabled={true} />
									</Form.Group>

									<Form.Group as={Col} xs={8}>
										<Form.Label className="text-2">{pageMessages.udaDescription}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.descricaoUDA}
											disabled={true} />
									</Form.Group>
								</Row>

								<Row>
									<Form.Group as={Col}>
										<Form.Label className="text-2">{pageMessages.nomeFornecedor}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.nomeFornecedor}
											disabled={true} />
									</Form.Group>
									<Form.Group as={Col} xs={2}>
										<Form.Label className="text-2">{pageMessages.semanaComercial}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.semanaComercial}
											disabled={true} />
									</Form.Group>
								</Row>
								<Row>
									<Form.Group as={Col}>
										<Form.Label className="text-2">{pageMessages.orderNumber}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.orderId}
											disabled={true} />
									</Form.Group>
									<Form.Group as={Col}>
										<Form.Label className="text-2">{pageMessages.naturezaPedido}</Form.Label>
										<Form.Control
											className="text-2 border-radius-full"
											type="text"
											defaultValue={lastCertificateDetails.naturezaPedido}
											disabled={true} />
									</Form.Group>
									<Form.Group as={Col} xs={4}>
										<Form.Label className="text-2">{pageMessages.auditStatus}</Form.Label>
										<div key={lastCertificateDetails.statusId}>
											<Form.Control
												as="select"
												className="text-2 border-radius-full"
												type="text"
												defaultValue={lastCertificateDetails.statusId ? lastCertificateDetails.statusId : "0"}
												onChange={event => updateFields(
													{ ...editableFields, statusId: event.target.value },
												)}
												disabled={blockEdit || isloadingSustainabilitySave}>
												{
													statusOptions.map(value => (
														<option key={value.id} value={value.id}>{value.message}</option>
													))
												}
											</Form.Control>
										</div>
									</Form.Group>
								</Row>
								{
									isAlgodaoBCI() &&
									<Row>
										<Form.Group as={Col}>
											<Form.Label className="text-2">{pageMessages.qtdBCCUs}</Form.Label>
											<Form.Control
												className="text-2 border-radius-full"
												type="number"
												defaultValue={lastCertificateDetails.qtdBCCUs}
												onChange={event => updateFields(
													{ ...editableFields, qtdBCCUs: event.target.value },
												)}
												disabled={blockEdit || isloadingSustainabilitySave} />
										</Form.Group>

										<Form.Group as={Col}>
											<Form.Label className="text-2">{pageMessages.codigoCertificadoODN}</Form.Label>
											<Form.Control
												className="text-2 border-radius-full"
												type="text"
												defaultValue={lastCertificateDetails.codigoCertificadoODN}
												onChange={event => updateFields(
													{ ...editableFields, codigoCertificadoODN: event.target.value },
												)}
												disabled={blockEdit || isloadingSustainabilitySave} />
										</Form.Group>
									</Row>
								}

								<Form.Label className="text-2 mb-1">{pageMessages.validCertificate}</Form.Label>
								<div key={`inline-radio`} className="text-2">
									<div key={lastCertificateDetails.certificadoValido}>
										<Form.Check
											inline
											label={messages[lang].no}
											name="validCertificateRadio"
											type="radio"
											defaultChecked={lastCertificateDetails.certificadoValido === "Não"}
											onChange={event => updateFields(
												{ ...editableFields, certificadoValido: "Não" },
											)}
											id={`inline-radio-1`}
											disabled={blockEdit || isloadingSustainabilitySave}
										/>
										<Form.Check
											inline
											label={messages[lang].yes}
											name="validCertificateRadio"
											type="radio"
											defaultChecked={lastCertificateDetails.certificadoValido === "Sim"}
											onChange={event => updateFields(
												{ ...editableFields, certificadoValido: "Sim" },
											)}
											id={`inline-radio-2`}
											disabled={blockEdit || isloadingSustainabilitySave}
										/>
									</div>
								</div>

								{
									!isAlgodaoBCI() &&
									<div>
										<Form.Label className="text-2 mt-2 mb-1">{pageMessages.certificadoComPeriodoVigenciaAtivo}</Form.Label>
										<div key={`inline-radio-periodo-vigencia-ativo`} className="text-2">
											<div key={lastCertificateDetails.certificadoComPeriodoVigenciaAtivo}>
												<Form.Check
													inline
													label={messages[lang].no}
													name="validCertificateRadioperiodo-vigencia-ativo"
													type="radio"
													defaultChecked={lastCertificateDetails.certificadoComPeriodoVigenciaAtivo === "Não"}
													onChange={event => updateFields(
														{ ...editableFields, certificadoComPeriodoVigenciaAtivo: "Não" },
													)}
													id={`inline-radio-periodo-vigencia-ativo-1`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
												<Form.Check
													inline
													label={messages[lang].yes}
													name="validCertificateRadioperiodo-vigencia-ativo"
													type="radio"
													defaultChecked={lastCertificateDetails.certificadoComPeriodoVigenciaAtivo === "Sim"}
													onChange={event => updateFields(
														{ ...editableFields, certificadoComPeriodoVigenciaAtivo: "Sim" },
													)}
													id={`inline-radio-periodo-vigencia-ativo-2`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
											</div>
										</div>
									</div>
								}

								{
									isAlgodaoBCI() &&
									<div>
										<Form.Label className="text-2 mt-2 mb-1">{pageMessages.buyerIDNumberIgualALoja}</Form.Label>
										<div key={`inline-radio-buyerIDNumberIgualALoja`} className="text-2">
											<div key={lastCertificateDetails.buyerIDNumberIgualALoja}>
												<Form.Check
													inline
													label={messages[lang].no}
													name="validCertificateRadiobuyerIDNumberIgualALoja"
													type="radio"
													defaultChecked={lastCertificateDetails.buyerIDNumberIgualALoja === "Não"}
													onChange={event => updateFields(
														{ ...editableFields, buyerIDNumberIgualALoja: "Não" },
													)}
													id={`inline-radio-buyerIDNumberIgualALoja-1`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
												<Form.Check
													inline
													label={messages[lang].yes}
													name="validCertificateRadiobuyerIDNumberIgualALoja"
													type="radio"
													defaultChecked={lastCertificateDetails.buyerIDNumberIgualALoja === "Sim"}
													onChange={event => updateFields(
														{ ...editableFields, buyerIDNumberIgualALoja: "Sim" },
													)}
													id={`inline-radio-buyerIDNumberIgualALoja-2`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
											</div>
										</div>
									</div>
								}

								{
									isAlgodaoBCI() &&
									<div>
										<Form.Label className="text-2 mt-2 mb-1">{pageMessages.codigoODNRepetido}</Form.Label>
										<div key={`inline-radio-codigoODNRepetido`} className="text-2">
											<div key={lastCertificateDetails.codigoODNRepetido}>
												<Form.Check
													inline
													label={messages[lang].no}
													name="validCertificateRadiocodigoODNRepetido"
													type="radio"
													defaultChecked={lastCertificateDetails.codigoODNRepetido === "Não"}
													onChange={event => updateFields(
														{ ...editableFields, codigoODNRepetido: "Não" },
													)}
													id={`inline-radio-codigoODNRepetido-1`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
												<Form.Check
													inline
													label={messages[lang].yes}
													name="validCertificateRadiocodigoODNRepetido"
													type="radio"
													defaultChecked={lastCertificateDetails.codigoODNRepetido === "Sim"}
													onChange={event => updateFields(
														{ ...editableFields, codigoODNRepetido: "Sim" },
													)}
													id={`inline-radio-codigoODNRepetido-2`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
											</div>
										</div>
									</div>
								}

								{
									isAlgodaoBCI() &&
									<div>
										<Form.Label className="text-2 mt-2 mb-1">{pageMessages.qtdBCCUsDentroDaMargemDeErro}</Form.Label>
										<div key={`inline-radio-qtdBCCUsDentroDaMargemDeErro`} className="text-2">
											<div key={lastCertificateDetails.qtdBCCUsDentroDaMargemDeErro}>
												<Form.Check
													inline
													label={messages[lang].no}
													name="validCertificateRadioqtdBCCUsDentroDaMargemDeErro"
													type="radio"
													defaultChecked={lastCertificateDetails.qtdBCCUsDentroDaMargemDeErro === "Não"}
													onChange={event => updateFields(
														{ ...editableFields, qtdBCCUsDentroDaMargemDeErro: "Não" },
													)}
													id={`inline-radio-qtdBCCUsDentroDaMargemDeErro-1`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
												<Form.Check
													inline
													label={messages[lang].yes}
													name="validCertificateRadioqtdBCCUsDentroDaMargemDeErro"
													type="radio"
													defaultChecked={lastCertificateDetails.qtdBCCUsDentroDaMargemDeErro === "Sim"}
													onChange={event => updateFields(
														{ ...editableFields, qtdBCCUsDentroDaMargemDeErro: "Sim" },
													)}
													id={`inline-radio-qtdBCCUsDentroDaMargemDeErro-2`}
													disabled={blockEdit || isloadingSustainabilitySave}
												/>
											</div>
										</div>
									</div>
								}

								<Form.Label className="text-2 mt-2 mb-1">{pageMessages.conciliacaoAprovada}</Form.Label>
								<div key={`inline-radio-conciliacaoAprovada`} className="text-2">
									<div key={lastCertificateDetails.conciliacaoAprovada}>
										<Form.Check
											inline
											label={messages[lang].no}
											name="validCertificateRadioconciliacaoAprovada"
											type="radio"
											defaultChecked={lastCertificateDetails.conciliacaoAprovada === "Não"}
											onChange={event => updateFields(
												{ ...editableFields, conciliacaoAprovada: "Não" },
											)}
											id={`inline-radio-conciliacaoAprovada-1`}
											disabled={blockEdit || isloadingSustainabilitySave}
										/>
										<Form.Check
											inline
											label={messages[lang].yes}
											name="validCertificateRadioconciliacaoAprovada"
											type="radio"
											defaultChecked={lastCertificateDetails.conciliacaoAprovada === "Sim"}
											onChange={event => updateFields(
												{ ...editableFields, conciliacaoAprovada: "Sim" },
											)}
											id={`inline-radio-conciliacaoAprovada-2`}
											disabled={blockEdit || isloadingSustainabilitySave}
										/>
									</div>
								</div>

								<Row>
									<Form.Group as={Col}>
										<Form.Label className="text-2 mt-2">{pageMessages.avaliacao}</Form.Label>
										<Form.Control
											as="textarea"
											className="text-2 border-radius-full"
											type="text"
											rows={2}
											defaultValue={lastCertificateDetails.avaliacao}
											onChange={event => updateFields(
												{ ...editableFields, avaliacao: event.target.value },
											)}
											disabled={blockEdit || isloadingSustainabilitySave} />
									</Form.Group>
								</Row>
								<Row>
									<Form.Group as={Col}>
										<Form.Label className="text-2">{pageMessages.anotacoes}</Form.Label>
										<Form.Control
											as="textarea"
											className="text-2 border-radius-full"
											type="text"
											rows={2}
											defaultValue={lastCertificateDetails.anotacoes}
											onChange={event => updateFields(
												{ ...editableFields, anotacoes: event.target.value },
											)}
											disabled={blockEdit || isloadingSustainabilitySave} />
									</Form.Group>
								</Row>
							</Form>
						</Container>

						<Container className="pt-3 justify-content-start">
							<Container className="mt-1 pt-1 mb-4 pb-5">
								<Form.Label className="text-2">{pageMessages.fileSustainabilityCertificate}</Form.Label>
								<UploadFiles
									validateAndStoreLocalFile={validateAndStoreLocalFile}
									uploadedFile={uploadedFile}
									removeFile={uploadedFile ? removeFile : null}
									downloadFile={null}
									accept={ACCEPT_TYPE}
								/>
							</Container>
						</Container>

						<Container className="pt-3 justify-content-start">
							<Container className="mt-1 pt-1 mb-4 pb-5">
								<ItemList
									header={header}
									titleTable={titleTable}
									listTable={certificateHistoryList ? mappedCertificateHistoryList() : []}
									isLoading={certificateHistoryList && certificateHistoryList.length > 0 ? false : true}
								/>
							</Container>
						</Container>
					</div>
			}
			<FooterActions
				ButtonGroupRight={saveButton(disableSaveButton)} />
		</div>
	)
}

export default withRouter(SustainabilityStatusPage);